module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/howto-step1-f2706c587820c47fa5b136ad204c9653.svg";